import { apiClient } from '@/config/api';
import { AttributeType, HydraCollection } from '@/types';

export const attributeTypeService = {
  // Get all attribute types
  async getAttributeTypes(): Promise<AttributeType[]> {
    const response = await apiClient.get<HydraCollection<AttributeType>>('/attribute_types', {
      params: {
        'groups[]': ['attributeType:read'],
        pagination: false, // Disable pagination to get all items
      },
    });

    const data = response.data;
    // Handle both paginated and non-paginated responses
    if (Array.isArray(data)) {
      return data;
    }
    return data['hydra:member'] || data['member'] || [];
  },
};
